
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/il-terroir",
      function () {
        return require("private-next-pages/il-terroir.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/il-terroir"])
      });
    }
  